import { Link, NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap } from "lucide-react";

const links = [
  { to: "/evidence", label: "Evidence" },
  { to: "/insights", label: "Insights" },
  { to: "/method", label: "Method" },
  { to: "/safety", label: "Safety" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const savedPlan = typeof window !== "undefined" ? localStorage.getItem("zb_plan_id") : null;

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className="fixed top-0 inset-x-0 z-50 bg-ink text-bone"
      data-testid="navbar"
    >
      <div className="h-[3px] bg-clay" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between gap-4 border-b border-bone/10">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-logo">
          <span className="relative flex h-2.5 w-2.5">
            <span className="zb-vitality-dot absolute inline-flex h-full w-full rounded-full bg-clay" />
          </span>
          <span className="font-serif text-2xl sm:text-3xl font-extrabold uppercase tracking-tight leading-none">
            Zinda<span className="text-clay">Banda</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-links">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-sans text-xs font-bold uppercase tracking-[0.18em] transition-colors duration-200 hover:text-clay ${
                  isActive ? "text-clay" : "text-bone/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          {savedPlan && (
            <NavLink
              to={`/plan/${savedPlan}`}
              data-testid="nav-link-my-plan"
              className="font-sans text-xs font-bold uppercase tracking-[0.18em] text-sage hover:text-clay transition-colors duration-200"
            >
              My plan
            </NavLink>
          )}
        </nav>

        {pathname !== "/check-in" && (
          <Link
            to="/check-in"
            data-testid="nav-cta-button"
            className="group inline-flex items-center gap-2 rounded-md bg-clay text-bone px-5 py-2.5 font-sans text-xs sm:text-sm font-bold uppercase tracking-wider transition-all duration-200 hover:bg-bone hover:text-ink active:scale-95 min-h-[44px]"
          >
            <Zap className="h-4 w-4 transition-transform duration-200 group-hover:rotate-12" />
            <span className="hidden sm:inline">Are you Zinda Banda?</span>
            <span className="sm:hidden">Take the test</span>
          </Link>
        )}
      </div>
    </motion.header>
  );
}
